// extracted by mini-css-extract-plugin
export default {"button":"Gl-z","reviewSort":"Hl-z"};